import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "PDF"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-pdf-box',
    templateUrl: './icon-pdf-box.component.html',
    styleUrls: ['./icon-pdf-box.component.scss'],
    standalone: false
})
export class IconPdfBoxComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
